import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t, i18n} = useTranslation();
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="col_selector d-md-flex justify-content-between">
              <a
                href="index.html"
                className="d-inline-block mt-1"
                style={{ width: 74 }}
              >
                <img
                  src="assets/images/logo-white.png"
                  className="img-fluid"
                  alt="logo"
                  height="50"
                  width="50"
                />
              </a>
              <ul className={`list-unstyled fz14 d-md-flex mt-3 mb-0  ${i18n.dir() === 'rtl' ? 'Almaraisemibold': 'poppinsregular'}`}>
                <li>
                  <Link className="nav-link" to="/contact-us">
                    {t('Contact Us')}
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/privacy-policy">
                    {t('Privacy Policy')}
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/terms-and-condition">
                    {t('Terms & Conditions')}
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/about">
                    {t('About')}
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/faq">
                    {t('FAQ')}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
